<template><svg
        viewBox="0 0 25 25"
        xmlns="http://www.w3.org/2000/svg"
>
    <path d="M9.57031 8.83789H16.1621V0.732422C16.1621 0.328125 15.834 0 15.4297 0H0.732422C0.328125 0 0 0.328125 0 0.732422V15.4297C0 15.834 0.328125 16.1621 0.732422 16.1621H8.83789V9.57031C8.83789 9.16602 9.16602 8.83789 9.57031 8.83789Z"/>
    <path d="M24.2676 8.83789H16.1621V15.4297C16.1621 15.834 15.834 16.1621 15.4297 16.1621H8.83789V24.2676C8.83789 24.6719 9.16602 25 9.57031 25H24.2676C24.6719 25 25 24.6719 25 24.2676V9.57031C25 9.16602 24.6719 8.83789 24.2676 8.83789Z"/>
</svg>
</template>